import { render, staticRenderFns } from "./Ibox.vue?vue&type=template&id=afdeb4e0&"
import script from "./Ibox.vue?vue&type=script&lang=js&"
export * from "./Ibox.vue?vue&type=script&lang=js&"
import style0 from "./Ibox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports